import http from '../request';

// 获取白板信息
const boardInfo = (boardId = '') => http.post(`/doris/board/boardInfo?boardId=${boardId}`);

// 获取患者病情信息
const getPatientIllness = (wbId = '') => http.post(`/doris/consult/getPatientIllness?wbId=${wbId}`);

// 更新白板信息
const updateBoard = (params) => http.post('/doris/board/updateBoard', { params, });

// 发起问诊创建问诊单
const createConsultOrder = (params) => http.post('/doris/consult/createConsultOrder', params);

// 发起问诊获取是否有问诊单
const preConsultation = (params) => http.post('/doris/porsche/preConsultation', params);

// 获取初诊医院
const getHospitals = (params) => http.post('/doris/doctor/getHospitals', params);

// 获取用户协议
const getConfigInfo = (params) => http.post('/nereus/user/protocol/getConfigInfo', params);

export {
  boardInfo,
  updateBoard,
  getPatientIllness,
  createConsultOrder,
  preConsultation,
  getHospitals,
  getConfigInfo
};
